import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const CategoriesProgressStyled = styled.span`
  display: block;
  padding-top: 0.4rem;
  ${typography.regular[18]};
  color: ${colors.neutral[900]};
  text-align: center;
  margin-bottom: 10.4rem;
`;
